export function makeNewCode(dbName, tableNames, tableDatas) {
  tableNames = JSON.parse(JSON.stringify(tableNames));
  tableDatas = JSON.parse(JSON.stringify(tableDatas));
  let newCode = "";
  // 导入依赖部分
  newCode = newCode + headCode;
  // 创建表单
  tableNames.forEach((tableName) => {
    newCode = newCode + setTableName(tableName);
  });
  // 初始化数据库文件
  newCode = newCode + initDB(dbName,tableNames,tableDatas);
  // 初始化数据库
  newCode = newCode + populateDB_();
  tableNames.forEach((tableName) => {
    newCode = newCode + populateDB(tableName, tableDatas[tableName]);
  });
  newCode = newCode + _populateDBLast;
  // 增删改查
  tableNames.forEach((tableName) => {
    let caud =
      addData(tableName, tableDatas[tableName]) +
      delData(tableName) +
      updateData(tableName, tableDatas[tableName]) +
      getData(tableName, tableDatas[tableName]) +
      getDataById(tableName, tableDatas[tableName]) +
      getDataBySearch(tableName, tableDatas[tableName]);
      // 在BySearh中集成了所有的搜索参数，如无必要不需要单独使用ByName搜索方法
      tableDatas[tableName].forEach(tableItem => {
        if (tableItem.name != 'id' && tableItem.searchTyp != 'none' && tableItem.searchTyp != null && tableItem.only) {
          caud = caud + getDataByName(tableName, tableDatas[tableName], tableItem.name, tableItem.typ, tableItem.searchTyp)
        }
      })
    newCode = newCode + caud;
  });
  newCode = newCode + footCode;
  return newCode;
}

export const headCode = `/// lib/db/db_helper.dart\n/// Author: Samle
import 'package:intl/intl.dart';
import 'package:path/path.dart';
import 'package:sqflite/sqflite.dart';

class DBHelper {
  static Database? db;
  static String? path;
`;
export function setTableName(tableName) {
  return `  final String ${tableName}TB = "${tableName}TB";  /// <<<<<<<< ${tableName}TB
`;
}
export function initDB(dbName,tableNames,tableDatas) {

  const addFieldStr_ = `\n\n      /// 在这里对本次新增的字段初始化构建一段用于新增字段的代码\n`
  let addFieldStr = ""
  tableNames.forEach((tableName) => {
    const thatTable = `${tableName}TB`
    tableDatas[tableName].forEach(tableItem => {
      if (tableItem.new) {
        addFieldStr = addFieldStr + `      if (!await checkField(db,${thatTable},"${tableItem.name}")) { await db.execute("ALTER TABLE $${thatTable} ADD COLUMN ${tableItem.name} ${tableItem.typ}"); } /// 添加字段 ${tableItem.name} 到表 ${thatTable}\n`
      }
    })
  });
  if (addFieldStr != "") {
    addFieldStr = addFieldStr_ + addFieldStr
  }
  // if (!await checkField(db,infoTB,"exitDate")) { await db.execute("ALTER TABLE $infoTB ADD COLUMN exitDate TEXT"); } /// 如：添加字段 exitDate 到表 infoTB

  return `  DBHelper._();

  /// 用于确认字段是否存在
  checkField(db,name,field) async {
    var table = await db.rawQuery("PRAGMA table_info($name)");
    bool columnExists = table.any((column) => column['name'] == field);
    // bool columnExists = false;
    // for (var column in table) {
    //   var columnName = column['name'] as String;
    //   if (columnName == field) {
    //     columnExists = true;
    //     return columnExists;
    //   }
    // }
    return columnExists;
  }
  
  /// 默认一个初始化标识，每次安装后重置该标识，每次完成字段增加后标识变更
  /// static bool hasAdd = false; // addFields 在初始化安装时执行，按逻辑不需要再判断是都需要新增字段
  /// 在这里定义增加字段方法
  addFields(db) async {
    /// 当标识校验通过，则执行增加字段程序
    /// if (!hasAdd) {
      /// 新增的字段要在这里插入数据库，否则会出现找不到字段的问题，如：添加字段 exitDate 到表 infoTB
      // if (!await checkField(db,infoTB,"exitDate")) { await db.execute("ALTER TABLE $infoTB ADD COLUMN exitDate TEXT"); }${addFieldStr}
      /// 更新完结后将标识状态修改，避免后续持续执行增加字段程序
      /// hasAdd = true;
      /// 除了增加字段程序外，最好在下方的初始化程序 populateDB 中加上对应字段
    /// }
  }

  /// 初始化数据库文件
  static bool hasInstall = false;
  Future<Database?> initDB() async {
    // 检测是否被安装，如果没有则执行初始化
    if (!hasInstall || db == null) {
      // print(">>> 初始化数据库");
      path = join(await getDatabasesPath(), '${dbName}.db');
      db = await openDatabase(
          path!,
          version: 1, // 当前数据库版本，当sqlite数据库结构发生变化时，需要更新此版本号
          onCreate: (db, ver) async => await populateDB(db),
          onUpgrade: (db, ver, newVer) async => await populateDB(db) // 更新逻辑将会重构数据库
      );
      await addFields(db);
      hasInstall = true;
      return db;
    }
    return db;
    // else {
      // print(">>> 数据库存在，仅更新字段");
      // await addFields(db);
      // return db;
    // }
  }
`;
}
export function populateDB_() {
  return `
  /// 初始化数据库
  populateDB(Database db) async {`;
}
export function _populateDB_(tableName) {
  return `
    /// <<<<<<<< ${tableName}  
    await db.execute(
      "CREATE TABLE IF NOT EXISTS $${tableName}TB(`;
}
export const _populateDB = `)");`;
export const _populateDBLast = `
  }
`;
export function populateDB(tableName, tableData) {
  let itemStr = "";
  tableData.forEach(tableItem => {
    if (itemStr != "") {
      itemStr = itemStr + `,${tableItem.name} ${tableItem.typ}`;
    } else {
      itemStr = itemStr + `${tableItem.name} ${tableItem.typ}`;
    }
  });
  return _populateDB_(tableName) + itemStr + _populateDB;
}
export function titleCase(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
}
export function addDataHead(tableName) {
  return `
  /// ${titleCase(tableName)} 表单新增实例
  Future<int> add${titleCase(tableName)}(Map dataForm) async {
    await initDB();
    String query =
      "INSERT INTO $${tableName}TB (`;
}
export function addDataField(tableData) {
  let fields = "";
  let holder = "";
  tableData.forEach(tableItem => {
    if (fields != "") {
      fields = fields + `, ${tableItem.name}`;
      holder = holder + ", ?";
    } else {
      fields = fields + `${tableItem.name}`;
      holder = holder + "?";
    }
  });
  return fields + ") VALUES(" + holder + ')";';
}
export function addDataList(tableData) {
  let listFirst = `
    List args = [
`;
  tableData.forEach(tableItem => {
    if (tableItem.typ == "TEXT") {
      listFirst = listFirst +
      `      (dataForm['${tableItem.name}'] != null ? dataForm['${tableItem.name}'].toString() : ''),
`
    } else {
      listFirst = listFirst +
      `      (dataForm['${tableItem.name}']),
`
    }
    
  });
  listFirst = listFirst.slice(0, -2);
  listFirst =
    listFirst +
    `
    ];
    var res = await db!.rawInsert(query, args);
    return res;
  }
`;
  return listFirst;
}
export function addData(tableName, tableData) {
  return (
    addDataHead(tableName) + addDataField(tableData) + addDataList(tableData)
  );
}
export function delData(tableName) {
  return `
  /// ${titleCase(tableName)} 表单删除实例
  Future<int> delete${titleCase(tableName)}(int id) async {
    await initDB();
    String query = "DELETE FROM $${tableName}TB WHERE id=$id";
    var res = await db!.rawDelete(query);
    return res;
  }
`;
}
export function updateData(tableName, tableData) {
  let updateStr = `
  /// ${titleCase(tableName)} 表单修改实例
  Future<int> update${titleCase(tableName)}(Map dataForm) async {
    await initDB();
    String query =
        'UPDATE $${tableName}TB SET `;
  let fields = "";
  tableData.forEach(tableItem => {
    if (tableItem.name != "id") {
      if (fields != "") {
        if (tableItem.typ == "TEXT") {
          fields = fields +
          `, ${tableItem.name} = \\\'\${dataForm['${tableItem.name}'] != null ? dataForm['${tableItem.name}'].toString() : ''}\\\'`
        } else {
          fields = fields +
          `, ${tableItem.name} = \\\'\${dataForm['${tableItem.name}']}\\\'`
        }
        
      } else {
        if (tableItem.typ == "TEXT") {
          fields = fields +
          ` ${tableItem.name} = \\\'\${dataForm['${tableItem.name}'] != null ? dataForm['${tableItem.name}'].toString() : ''}\\\'`
        } else {
          fields = fields +
          ` ${tableItem.name} = \\\'\${dataForm['${tableItem.name}']}\\\'`
        }
      }
    }
  });
  return (
    updateStr +
    fields +
    ` WHERE id = \${dataForm['id']}';
    var res = await db!.rawUpdate(query);
    return res;
  }
`
  );
}
export function getData(tableName, tableData) {
  let getDataStart = `
  /// ${titleCase(tableName)} 表单查询实例
  Future<List<Map>> get${titleCase(tableName)}() async {
    await initDB();
    String query = "SELECT * FROM $${tableName}TB";
    /// 需要排序按需添加
    /// query = query + " ORDER BY id DESC , updateTime ASC";
    List<Map<String, dynamic>> res = await db!.rawQuery(query);
    return List.generate(
      res.length,
      (i) => {
`;
  let listFirst = "";
  tableData.forEach(tableItem => {
    listFirst =
      listFirst +
      `        "${tableItem.name}": res[i]['${tableItem.name}'],
`;
  });
  let getDataLast = `      },
    );
  }
`;
  return getDataStart + listFirst + getDataLast;
}
export function getDataById(tableName, tableData) {
  let getDataStart = `
  /// ${titleCase(tableName)} 表单查询单一实例
  Future<Map> get${titleCase(tableName)}ById(int id) async {
    await initDB();
    String query = "SELECT * FROM $${tableName}TB WHERE id=$id";
    List<Map<String, dynamic>> res = await db!.rawQuery(query);
    if (res.isNotEmpty) {
      return {
`;
  let listFirst = "";
  tableData.forEach(tableItem => {
    listFirst =
      listFirst +
      `        "${tableItem.name}": res[0]['${tableItem.name}'],
`;
  });
  let getDataLast = `      };
    } else {
      return {};
    }
  }
`;
  return getDataStart + listFirst + getDataLast;
}
export function searchStr(tableData) {
  let searchStr_ = "";
  tableData.forEach(tableItem => {
    if (tableItem.search) {
      if (searchStr_ != "") {
        searchStr_ = searchStr_ + ` or ${tableItem.name} LIKE '%\${paramsForm['search']}%'`;
      } else {
        searchStr_ = searchStr_ + ` ${tableItem.name} LIKE '%\${paramsForm['search']}%'`;
      }
    }
  });
  if (searchStr_ != "") {
    return `(${searchStr_} )`;
  } else {
    return "";
  }
}

export function getParamsStr(tableData) {
  let paramsMap_ = `
    /// 参数搜索类型
    Map paramsMap = {`
  tableData.forEach(tableItem => {
    paramsMap_ = paramsMap_ + `
      '${tableItem.name}': '${tableItem.searchTyp}',`
  })
  paramsMap_ = paramsMap_ + `
    };`
  return  `${paramsMap_}
    String queryParams = "";
    paramsForm.forEach((key, value) {
      if (value != null && value != "") {
        String params = "";
        /// 时间参数需要自行按照如下样式进行调整
        if (key == "endTimeStart") {
          String newValue = DateFormat('yyyy-MM-dd').format(DateTime.parse(value)) + " 00:00:00";
          params = " datetime(endTime) >= datetime('$newValue')  ";
        } else if (key == "endTimeEnd") {
          String newValue = DateFormat('yyyy-MM-dd').format(DateTime.parse(value)) + " 23:59:59";
          params = " datetime(endTime) <= datetime('$newValue')  ";
        } else if (key == "startTimeStart") {
          String newValue = DateFormat('yyyy-MM-dd').format(DateTime.parse(value)) + " 00:00:00";
          params = " datetime(startTime) >= datetime('$newValue')  ";
        } else if (key == "startTimeEnd") {
          String newValue = DateFormat('yyyy-MM-dd').format(DateTime.parse(value)) + " 23:59:59";
          params = " datetime(startTime) <= datetime('$newValue')  ";
        } else if (key != "id") {
          if ( paramsMap.containsKey(key) && paramsMap[key] == 'equal'){
            params = " $key = '$value' ";
          } else if ( paramsMap.containsKey(key) && paramsMap[key] == 'like' ) {
            params = " $key LIKE '%$value%' ";
          }
        } else if (key == "id") {
          params = " $key = '$value' ";
        }
        if ( params != "" ) {
          if ( queryParams != "" ) {
            queryParams = queryParams + " and " + params;
          } else {
            queryParams = queryParams + params;
          }
        }
      }
    });`
}
export function getDataBySearch(tableName, tableData) {
  let searchStr_ = searchStr(tableData);
  let paramsStr_ = getParamsStr(tableData)
  let getDataStart = `
  /// ${titleCase(tableName)} 表单查询搜索实例
  Future<List<Map>> get${titleCase(tableName)}BySearch(Map paramsForm) async {
    await initDB();
    String query = "SELECT * FROM $${tableName}TB";${searchStr_ != ''?`
    /// 设置统一搜索
    String searchStr = "";
    if (paramsForm['search'] != null && paramsForm['search'] != '') {
      searchStr = "` + searchStr_ + `";
    }`:""}${paramsStr_}${searchStr_ != ''?`
    queryParams = (searchStr != "" ? (queryParams != "" ? searchStr + " and ": searchStr):"") + queryParams;`:''}
    if ( queryParams != "" ) { query = query + " WHERE " + queryParams; }
    /// 需要排序按需添加
    /// query = query + " ORDER BY id DESC , updateTime ASC";
    /// 按参数判断是否分页
    if (paramsForm.containsKey('pageSize') && paramsForm['pageSize'] != null && paramsForm['pageSize'] != '' && paramsForm['pageSize'] != 'null' && paramsForm.containsKey('pageNum') && paramsForm['pageNum'] != null && paramsForm['pageNum'] != '' && paramsForm['pageNum'] != 'null') {
      var pageSize = int.parse(paramsForm['pageSize'].toString());
      var pageNum = int.parse(paramsForm['pageNum'].toString());
      query = query + "  Limit \$pageSize Offset \${pageSize * (pageNum - 1)}";
    }
    List<Map<String, dynamic>> res = await db!.rawQuery(query);
    return List.generate(
      res.length,
      (i) => {
`;
    let listFirst = "";
    tableData.forEach(tableItem => {
      listFirst =
        listFirst +
        `        "${tableItem.name}": res[i]['${tableItem.name}'],
`;
    });
    let getDataLast = `      },
    );
  }
`;
  return getDataStart + listFirst + getDataLast;
}
export function getFiledTyp(filedTyp){
  if (filedTyp == 'TEXT') {
    return 'String'
  } else if (filedTyp == 'INTEGER' || filedTyp == 'INTEGER PRIMARY KEY AUTOINCREMENT') {
    return 'int'
  } else {
    return 'dynamic'
  }
}
export function getDataByName(tableName, tableData, fieldName, filedTyp, fieldSearchType) {
  let getDataStart = `
  /// ${titleCase(tableName)} 表单按条件查询实例
  /// 在 get${titleCase(tableName)}BySearch(Map paramsForm) 中集成了所有的搜索参数，如无必要不需要单独使用此搜索方法
  Future<List<Map>> get${titleCase(tableName)}By${titleCase(fieldName)}(${getFiledTyp(filedTyp)} ${fieldName}) async {
    await initDB();
    String query = "SELECT * FROM $${tableName}TB WHERE ${fieldName} ${fieldSearchType=="equal"?"=":"LIKE"} '${fieldSearchType=="equal"?"":"%"}$${fieldName}${fieldSearchType=="equal"?"":"%"}'";
    /// 需要排序按需添加
    /// query = query + " ORDER BY id DESC , updateTime ASC";
    List<Map<String, dynamic>> res = await db!.rawQuery(query);
    return List.generate(
      res.length,
      (i) => {
`;
  let listFirst = "";
  tableData.forEach(tableItem => {
    listFirst =
      listFirst +
      `        "${tableItem.name}": res[i]['${tableItem.name}'],
`;
  });
  let getDataLast = `      },
    );
  }
`;
  return getDataStart + listFirst + getDataLast;
}

export const footCode = `
}

DBHelper localData = DBHelper._();

/// 特别说明：避免影响原始数据库 db_helper 文件的拓展序列化方法
/// 在 lib/db/db_helper.dart 同级创建序列化文件 lib/db/db_serializer.dart
/// import 'package:intl/intl.dart';
/// import 'db_helper.dart';
/// extension Serilizer on DBHelper {
/// 写入适当的序列化方法
///   Future<Map> getTables() async {
///     await initDB();
///     String query = "SELECT * FROM $tableTB";
///     List<Map<String, dynamic>> res = await DBHelper.db!.rawQuery(query);
///     ~ ~ ~ ~ ~ ~
///   }
/// }

/// 调用方法与db_helper文件中的方法一致
/// await localData.getTables();
`;
